import type { RefObject } from 'react';

import type { SxProps, Theme } from '@mui/material';
import { Box } from '@mui/material';

import { DashboardCMACard } from './dashboard-cma/DashboardCMACard';
import { DashboardEnquiriesCard } from './dashboard-enquiry/DashboardEnquiriesCard';
import { DashboardLeadsCard } from './dashboard-lead/DashboardLeadsCard';
import { DashboardListingsCard } from './dashboard-listings/DashboardListingsCard';
import { DashboardMlsShareRequestsCard } from './dashboard-mls-share-requests/DashboardMlsShareRequestsCard';
import { DashboardTasksCard } from './dashboard-task/DashboardTasksCard';
import { DashboardStatsCard } from './DashboardStatsCard';
import { CollapsibleFeed } from './shared/CollapsibleFeed';
import { useDashboardModules } from './shared/useDashboardModules';
import { type RetryableRef } from './types';

const columnSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  minWidth: 0,
};

type DashboardDesktopViewProps = {
  enquiriesRef: RefObject<RetryableRef | null>;
};

export const DashboardDesktopView = ({
  enquiriesRef,
}: DashboardDesktopViewProps) => {
  const { isBrokerageEnabled, isCMAEnabled } = useDashboardModules();

  return (
    <>
      <Box sx={columnSx}>
        {isBrokerageEnabled && <DashboardEnquiriesCard ref={enquiriesRef} />}
        <DashboardLeadsCard />
        <DashboardTasksCard />
        {isCMAEnabled && <DashboardCMACard />}
        {isBrokerageEnabled && <DashboardListingsCard />}
        {isBrokerageEnabled && <DashboardMlsShareRequestsCard />}

        <CollapsibleFeed showHeader />
      </Box>

      <Box sx={columnSx}>
        <DashboardStatsCard />
      </Box>
    </>
  );
};
